import React from 'react';
import PointIssueHistoryListSearchBox from '../PointIssueHistoryListSearchBox';
import PointIssueHistoryList from '../PointIssueHistoryList';
import { _LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

const PointIssueHistoryListWrap = (props) => {
  const { pointIssueHistoryList, getList, setData, adminSelectList } = props;

  return (
    <div className="point-issue-history-wrap">
      {/*포인트 발급 리스트 검색 박스*/}
      <PointIssueHistoryListSearchBox
        setData={(data) =>
          setData({
            path: ['pointIssueHistoryList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        adminSelectList={adminSelectList}
        searchData={pointIssueHistoryList.searchData}
        getList={getList}
      />

      {/*포인트 발급 리스트*/}
      <PointIssueHistoryList
        pointIssueHistoryList={pointIssueHistoryList.list}
        initialOption={{
          pagination: _LIST_PAGINATION_MODEL,
        }}
        pagination={pointIssueHistoryList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default PointIssueHistoryListWrap;
